export default {
    A1: {
        t: 's',
        v: '#',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    B1: {
        t: 's',
        v: '還款日期',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    C1: {
        t: 's',
        v: '還款本金',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    D1: {
        t: 's',
        v: '利息',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    E1: {
        t: 's',
        v: '扣款總額',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    F1: {
        t: 's',
        v: '借款餘額',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    G1: {
        t: 's',
        v: '扣款銀行帳戶',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    H1: {
        t: 's',
        v: '備註',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    '!ref': 'A1:H1',
};
